import { Button, Paper, Stack, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { ReactNode } from 'react'
import ServiceModal from '../../../components/ServiceModal'
import TaskRollbackModal from '../../../components/TaskRollbackModal'

interface TaskWrapperProps {
  label: string
  task: any
  onSave: () => void
  saveButtonLabel?: string
  children: ReactNode
  sx?: Record<string, any>
  isCanceled?: boolean
  disabled?: boolean
  rightContent?: ReactNode
}

export default function TaskWrapper({
  label,
  task,
  onSave,
  saveButtonLabel,
  children,
  sx,
  isCanceled = false,
  disabled,
  rightContent
}: TaskWrapperProps) {
  console.log('label', label)
  console.log('onSave - ', task)
  const enabled =
    typeof disabled === 'undefined'
      ? task.isActive && task.accessFlags.update && !isCanceled
      : !disabled

  return (
    <Paper
      sx={{
        position: 'relative',
        padding: '1rem',
        borderRadius: '1rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        ...sx
      }}
      elevation={0}
    >
      <Box display="flex" flexDirection="column" alignItems="flex-start">
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          width="100%"
        >
          <Stack
            direction={'row'}
            width="100%"
            justifyContent={'space-between'}
          >
            <Typography
              variant="h6"
              fontWeight="bold"
              color={task.isActive ? 'black' : 'gray'}
            >
              {label}
            </Typography>
            {!!rightContent && rightContent}
          </Stack>
          {task.isFinished && (
            <Typography color="success.main">{task.finisher.name} ✓</Typography>
          )}
        </Box>
        {task.isActive && task.accessFlags?.changeResponsibleUser && (
          <Box display="flex" alignItems="center" gap={1}>
            <small>
              Ответственные:{' '}
              {task.responsibleUsers.map((u: any) => u.name).join(', ') || 'нет'}
            </small>
            <ServiceModal
              task={task}
              isCanceled={isCanceled}
            />
          </Box>
        )}
      </Box>

      {children}

      {enabled && (
        <Box
          display="flex"
          justifyContent="space-between"
          sx={{ marginTop: 'auto' }}
        >
          <Button
            variant="contained"
            onClick={onSave}
            disableElevation
            disabled={isCanceled}
          >
            {saveButtonLabel || 'Сохранить'}
          </Button>
          <TaskRollbackModal task={task} disabled={isCanceled} />
        </Box>
      )}

      {task.timeSpent && task.executionTime && (
        <small
          style={{ marginTop: 'auto', marginLeft: 'auto' }}
        >{`${task.timeSpent} / ${task.executionTime}`}</small>
      )}

      {enabled && task.rollbackMessage && (
        <Box display="flex" flexDirection="column">
          <Typography color="red" fontWeight="bold">
            Задание было возвращено в работу с пометкой:
          </Typography>
          <Typography>{task.rollbackMessage}</Typography>
        </Box>
      )}
    </Paper>
  )
}
